import type { Invoice } from '@/types/payments';

type AccountFields = Pick<Invoice,
  'vendorIban' | 'vendorBankgiro' | 'vendorPlusgiro' |
  'vendorAccountNumber' | 'vendorClearingNumber'
>;

export function formatVendorAccount(fields: AccountFields): string {
  if (fields.vendorIban) return `IBAN: ${fields.vendorIban}`;
  if (fields.vendorBankgiro) return `Bankgiro: ${fields.vendorBankgiro}`;
  if (fields.vendorPlusgiro) return `Plusgiro: ${fields.vendorPlusgiro}`;
  if (fields.vendorAccountNumber && fields.vendorClearingNumber)
    return `Account: ${fields.vendorAccountNumber}, Clearing: ${fields.vendorClearingNumber}`;
  return '';
}

export function hasVendorAccount(fields: Pick<AccountFields, 'vendorIban' | 'vendorBankgiro' | 'vendorPlusgiro' | 'vendorAccountNumber'>): boolean {
  return !!(fields.vendorIban || fields.vendorBankgiro || fields.vendorPlusgiro || fields.vendorAccountNumber);
}